import { registerListener } from "./useListeners";

const keyupKey = "keyup";
export const useKeyupListener = registerListener(window, keyupKey);

export const includesKeys = (e, ...keys) => keys.includes(e.code);
